export default __webpack_public_path__ + "static/media/souvenirsLogo.69aa16c1.png";